// Global state
let isProcessing = false;
let currentCurrency = 'INR';
let observerInitialized = false;

function getCurrentCurrency() {
const glcSwitcher = localStorage.getItem('glc_switcher');
if (glcSwitcher) {
    try {
    const data = JSON.parse(glcSwitcher);
    currentCurrency = data.value?.currency || 'INR';
    } catch (e) {
    currentCurrency = 'INR';
    }
}

const currencyIndicator = document.querySelector('[data-currency], .currency-code, .currency-indicator');
if (currencyIndicator && currencyIndicator.textContent) {
    const text = currencyIndicator.textContent.trim().toUpperCase();
    const match = text.match(/INR|USD|EUR|GBP|CAD|AUD/);
    if (match) {
    currentCurrency = match[0];
    }
}

return currentCurrency;
}

function getGLCCountryData() {
const glcSwitcher = localStorage.getItem('glc_switcher');
if (glcSwitcher) {
    try {
    const data = JSON.parse(glcSwitcher);
    return {
        country: data.value?.country || 'IN',
        currency: data.value?.currency || 'INR',
        locale: data.value?.locale || 'en'
    };
    } catch (e) {
    console.error('Error parsing glc_switcher:', e);
    return { country: 'IN', currency: 'INR', locale: 'en' };
    }
}
return { country: 'IN', currency: 'INR', locale: 'en' };
}

// Get exchange rates from GLC
function getGLCExchangeRates() {
const glcRates = localStorage.getItem('glc_rates');
if (glcRates) {
    try {
    const data = JSON.parse(glcRates);
    return data.value || {};
    } catch (e) {
    console.error('Error parsing glc_rates:', e);
    return {};
    }
}
return {};
}

// Convert price from INR (base currency) to target currency
function convertCurrency(priceInINR, targetCurrency) {
if (targetCurrency === 'INR') {
    return Math.round(priceInINR * 100) / 100; // Round to 2 decimals
}

const rates = getGLCExchangeRates();
const inrRate = rates['INR']; // How much USD is 1 INR
const targetRate = rates[targetCurrency]; // How much USD is 1 target currency

if (!inrRate || !targetRate) {
    console.warn(`Exchange rate for INR or ${targetCurrency} not found, using original price`);
    return Math.round(priceInINR * 100) / 100;
}

// Convert: INR → USD → Target Currency
// Step 1: Convert INR to USD
const priceInUSD = priceInINR * inrRate;
// Step 2: Convert USD to target currency
const convertedPrice = priceInUSD / targetRate;
const roundedPrice = Math.round(convertedPrice * 100) / 100;

console.log(`Converting ${priceInINR} INR to ${targetCurrency}: (${priceInINR} * ${inrRate}) / ${targetRate} = ${roundedPrice}`);

return roundedPrice;
}

// Get default shipping address details for countries that require them
function getDefaultShippingAddress(countryCode) {
// Country-specific defaults for shipping calculation
const countryDefaults = {
    // North America
    'US': { province: 'NY', zip: '10001', city: 'New York' },
    'CA': { province: 'ON', zip: 'M5V 3A8', city: 'Toronto' },
    'MX': { province: '', zip: '01000', city: 'Mexico City' },
    
    // Central America
    'GT': { province: '', zip: '01001', city: 'Guatemala City' },
    'BZ': { province: '', zip: '', city: 'Belize City' },
    'SV': { province: '', zip: '1101', city: 'San Salvador' },
    'HN': { province: '', zip: '11101', city: 'Tegucigalpa' },
    'NI': { province: '', zip: '10000', city: 'Managua' },
    'CR': { province: '', zip: '10101', city: 'San José' },
    'PA': { province: '', zip: '0801', city: 'Panama City' },
    
    // Caribbean
    'CU': { province: '', zip: '10100', city: 'Havana' },
    'JM': { province: '', zip: 'Kingston 1', city: 'Kingston' },
    'HT': { province: '', zip: 'HT6110', city: 'Port-au-Prince' },
    'DO': { province: '', zip: '10100', city: 'Santo Domingo' },
    'PR': { province: '', zip: '00901', city: 'San Juan' },
    'TT': { province: '', zip: '', city: 'Port of Spain' },
    'BB': { province: '', zip: 'BB11000', city: 'Bridgetown' },
    'BS': { province: '', zip: '', city: 'Nassau' },
    'KY': { province: '', zip: 'KY1-1100', city: 'George Town' },
    'BM': { province: '', zip: 'HM 11', city: 'Hamilton' },
    'GD': { province: '', zip: '', city: 'St. Georges' },
    'LC': { province: '', zip: '', city: 'Castries' },
    'VC': { province: '', zip: 'VC0100', city: 'Kingstown' },
    'AG': { province: '', zip: '', city: 'St. Johns' },
    'DM': { province: '', zip: '', city: 'Roseau' },
    'KN': { province: '', zip: '', city: 'Basseterre' },
    'AW': { province: '', zip: '', city: 'Oranjestad' },
    'CW': { province: '', zip: '', city: 'Willemstad' },
    'VG': { province: '', zip: 'VG1110', city: 'Road Town' },
    
    // South America
    'BR': { province: '', zip: '01000-000', city: 'São Paulo' },
    'AR': { province: '', zip: 'C1002', city: 'Buenos Aires' },
    'CL': { province: '', zip: '8320000', city: 'Santiago' },
    'CO': { province: '', zip: '110111', city: 'Bogotá' },
    'PE': { province: '', zip: '15001', city: 'Lima' },
    'VE': { province: '', zip: '1010', city: 'Caracas' },
    'EC': { province: '', zip: '170150', city: 'Quito' },
    'UY': { province: '', zip: '11000', city: 'Montevideo' },
    'PY': { province: '', zip: '1101', city: 'Asunción' },
    'BO': { province: '', zip: '', city: 'La Paz' },
    'GY': { province: '', zip: '', city: 'Georgetown' },
    'SR': { province: '', zip: '', city: 'Paramaribo' },
    'GF': { province: '', zip: '97300', city: 'Cayenne' },
    'FK': { province: '', zip: 'FIQQ 1ZZ', city: 'Stanley' },
    
    // Western Europe
    'GB': { province: '', zip: 'SW1A 1AA', city: 'London' },
    'IE': { province: '', zip: 'D01', city: 'Dublin' },
    'FR': { province: '', zip: '75001', city: 'Paris' },
    'DE': { province: '', zip: '10115', city: 'Berlin' },
    'IT': { province: '', zip: '00118', city: 'Rome' },
    'ES': { province: '', zip: '28001', city: 'Madrid' },
    'PT': { province: '', zip: '1000-001', city: 'Lisbon' },
    'NL': { province: '', zip: '1012 JS', city: 'Amsterdam' },
    'BE': { province: '', zip: '1000', city: 'Brussels' },
    'LU': { province: '', zip: 'L-1009', city: 'Luxembourg' },
    'AT': { province: '', zip: '1010', city: 'Vienna' },
    'CH': { province: '', zip: '8001', city: 'Zurich' },
    'MC': { province: '', zip: '98000', city: 'Monaco' },
    'AD': { province: '', zip: 'AD500', city: 'Andorra la Vella' },
    'LI': { province: '', zip: '9490', city: 'Vaduz' },
    'SM': { province: '', zip: '47890', city: 'San Marino' },
    'VA': { province: '', zip: '00120', city: 'Vatican City' },
    'GI': { province: '', zip: 'GX11 1AA', city: 'Gibraltar' },
    
    // Nordic Countries
    'DK': { province: '', zip: '1050', city: 'Copenhagen' },
    'SE': { province: '', zip: '111 29', city: 'Stockholm' },
    'NO': { province: '', zip: '0010', city: 'Oslo' },
    'FI': { province: '', zip: '00100', city: 'Helsinki' },
    'IS': { province: '', zip: '101', city: 'Reykjavik' },
    'FO': { province: '', zip: 'FO-100', city: 'Tórshavn' },
    'GL': { province: '', zip: '3900', city: 'Nuuk' },
    'AX': { province: '', zip: '22100', city: 'Mariehamn' },
    'SJ': { province: '', zip: '9170', city: 'Longyearbyen' },
    
    // Eastern Europe
    'PL': { province: '', zip: '00-001', city: 'Warsaw' },
    'CZ': { province: '', zip: '110 00', city: 'Prague' },
    'SK': { province: '', zip: '811 01', city: 'Bratislava' },
    'HU': { province: '', zip: '1011', city: 'Budapest' },
    'RO': { province: '', zip: '010011', city: 'Bucharest' },
    'BG': { province: '', zip: '1000', city: 'Sofia' },
    'HR': { province: '', zip: '10000', city: 'Zagreb' },
    'SI': { province: '', zip: '1000', city: 'Ljubljana' },
    'EE': { province: '', zip: '10111', city: 'Tallinn' },
    'LV': { province: '', zip: 'LV-1010', city: 'Riga' },
    'LT': { province: '', zip: '01100', city: 'Vilnius' },
    'GR': { province: '', zip: '105 57', city: 'Athens' },
    'CY': { province: '', zip: '1010', city: 'Nicosia' },
    'MT': { province: '', zip: 'VLT 1117', city: 'Valletta' },
    'AL': { province: '', zip: '1000', city: 'Tirana' },
    'MK': { province: '', zip: '1000', city: 'Skopje' },
    'RS': { province: '', zip: '11000', city: 'Belgrade' },
    'BA': { province: '', zip: '71000', city: 'Sarajevo' },
    'ME': { province: '', zip: '81000', city: 'Podgorica' },
    'XK': { province: '', zip: '10000', city: 'Pristina' },
    'MD': { province: '', zip: 'MD-2001', city: 'Chișinău' },
    
    // Russia & Former Soviet Union
    'RU': { province: '', zip: '101000', city: 'Moscow' },
    'BY': { province: '', zip: '220050', city: 'Minsk' },
    'UA': { province: '', zip: '01001', city: 'Kyiv' },
    'KZ': { province: '', zip: '010000', city: 'Astana' },
    'UZ': { province: '', zip: '100000', city: 'Tashkent' },
    'TM': { province: '', zip: '744000', city: 'Ashgabat' },
    'TJ': { province: '', zip: '734001', city: 'Dushanbe' },
    'KG': { province: '', zip: '720001', city: 'Bishkek' },
    'AM': { province: '', zip: '0010', city: 'Yerevan' },
    'GE': { province: '', zip: '0101', city: 'Tbilisi' },
    'AZ': { province: '', zip: 'AZ1000', city: 'Baku' },
    
    // Middle East
    'AE': { province: '', zip: '', city: 'Dubai' },
    'SA': { province: '', zip: '11564', city: 'Riyadh' },
    'IL': { province: '', zip: '6119101', city: 'Tel Aviv' },
    'TR': { province: '', zip: '34000', city: 'Istanbul' },
    'QA': { province: '', zip: '', city: 'Doha' },
    'KW': { province: '', zip: '', city: 'Kuwait City' },
    'BH': { province: '', zip: '', city: 'Manama' },
    'OM': { province: '', zip: '100', city: 'Muscat' },
    'JO': { province: '', zip: '11118', city: 'Amman' },
    'LB': { province: '', zip: '', city: 'Beirut' },
    'IQ': { province: '', zip: '10001', city: 'Baghdad' },
    'IR': { province: '', zip: '11369', city: 'Tehran' },
    'SY': { province: '', zip: '', city: 'Damascus' },
    'YE': { province: '', zip: '', city: 'Sanaa' },
    'PS': { province: '', zip: '', city: 'Ramallah' },
    
    // South Asia
    'IN': { province: '', zip: '110001', city: 'New Delhi' },
    'PK': { province: '', zip: '44000', city: 'Islamabad' },
    'BD': { province: '', zip: '1000', city: 'Dhaka' },
    'LK': { province: '', zip: '00100', city: 'Colombo' },
    'NP': { province: '', zip: '44600', city: 'Kathmandu' },
    'BT': { province: '', zip: '11001', city: 'Thimphu' },
    'MV': { province: '', zip: '20002', city: 'Malé' },
    'AF': { province: '', zip: '1001', city: 'Kabul' },
    
    // Southeast Asia
    'TH': { province: '', zip: '10200', city: 'Bangkok' },
    'VN': { province: '', zip: '100000', city: 'Hanoi' },
    'PH': { province: '', zip: '1000', city: 'Manila' },
    'ID': { province: '', zip: '10110', city: 'Jakarta' },
    'MY': { province: '', zip: '50000', city: 'Kuala Lumpur' },
    'SG': { province: '', zip: '018989', city: 'Singapore' },
    'MM': { province: '', zip: '11011', city: 'Yangon' },
    'KH': { province: '', zip: '12301', city: 'Phnom Penh' },
    'LA': { province: '', zip: '01000', city: 'Vientiane' },
    'BN': { province: '', zip: 'BS8811', city: 'Bandar Seri Begawan' },
    'TL': { province: '', zip: '', city: 'Dili' },
    
    // East Asia
    'CN': { province: '', zip: '100000', city: 'Beijing' },
    'JP': { province: '', zip: '100-0001', city: 'Tokyo' },
    'KR': { province: '', zip: '04524', city: 'Seoul' },
    'KP': { province: '', zip: '', city: 'Pyongyang' },
    'TW': { province: '', zip: '100', city: 'Taipei' },
    'HK': { province: '', zip: '', city: 'Hong Kong' },
    'MO': { province: '', zip: '', city: 'Macau' },
    'MN': { province: '', zip: '14200', city: 'Ulaanbaatar' },
    
    // Oceania & Pacific
    'AU': { province: 'NSW', zip: '2000', city: 'Sydney' },
    'NZ': { province: '', zip: '1010', city: 'Auckland' },
    'PG': { province: '', zip: '111', city: 'Port Moresby' },
    'FJ': { province: '', zip: '', city: 'Suva' },
    'NC': { province: '', zip: '98800', city: 'Nouméa' },
    'PF': { province: '', zip: '98714', city: 'Papeete' },
    'WS': { province: '', zip: '', city: 'Apia' },
    'SB': { province: '', zip: '', city: 'Honiara' },
    'VU': { province: '', zip: '', city: 'Port Vila' },
    'TO': { province: '', zip: '', city: 'Nukualofa' },
    'KI': { province: '', zip: '', city: 'Tarawa' },
    'FM': { province: '', zip: '96941', city: 'Palikir' },
    'MH': { province: '', zip: '96960', city: 'Majuro' },
    'PW': { province: '', zip: '96940', city: 'Ngerulmud' },
    'NR': { province: '', zip: '', city: 'Yaren' },
    'TV': { province: '', zip: '', city: 'Funafuti' },
    'GU': { province: '', zip: '96910', city: 'Hagåtña' },
    'AS': { province: '', zip: '96799', city: 'Pago Pago' },
    'MP': { province: '', zip: '96950', city: 'Saipan' },
    'CK': { province: '', zip: '', city: 'Avarua' },
    'NU': { province: '', zip: '', city: 'Alofi' },
    'WF': { province: '', zip: '98600', city: 'Mata-Utu' },
    
    // North Africa
    'EG': { province: '', zip: '11511', city: 'Cairo' },
    'LY': { province: '', zip: '', city: 'Tripoli' },
    'TN': { province: '', zip: '1000', city: 'Tunis' },
    'DZ': { province: '', zip: '16000', city: 'Algiers' },
    'MA': { province: '', zip: '10000', city: 'Rabat' },
    'SD': { province: '', zip: '11111', city: 'Khartoum' },
    'SS': { province: '', zip: '', city: 'Juba' },
    'EH': { province: '', zip: '', city: 'Laayoune' },
    
    // West Africa
    'NG': { province: '', zip: '100001', city: 'Lagos' },
    'GH': { province: '', zip: 'GA-123-4567', city: 'Accra' },
    'CI': { province: '', zip: '', city: 'Abidjan' },
    'SN': { province: '', zip: '10000', city: 'Dakar' },
    'ML': { province: '', zip: '', city: 'Bamako' },
    'BF': { province: '', zip: '01', city: 'Ouagadougou' },
    'NE': { province: '', zip: '', city: 'Niamey' },
    'GN': { province: '', zip: '001', city: 'Conakry' },
    'SL': { province: '', zip: '', city: 'Freetown' },
    'LR': { province: '', zip: '1000', city: 'Monrovia' },
    'TG': { province: '', zip: '', city: 'Lomé' },
    'BJ': { province: '', zip: '', city: 'Porto-Novo' },
    'GM': { province: '', zip: '', city: 'Banjul' },
    'GW': { province: '', zip: '1000', city: 'Bissau' },
    'MR': { province: '', zip: '', city: 'Nouakchott' },
    'CV': { province: '', zip: '7600', city: 'Praia' },
    'ST': { province: '', zip: '', city: 'São Tomé' },
    
    // East Africa
    'KE': { province: '', zip: '00100', city: 'Nairobi' },
    'TZ': { province: '', zip: '11101', city: 'Dar es Salaam' },
    'UG': { province: '', zip: '', city: 'Kampala' },
    'ET': { province: '', zip: '1000', city: 'Addis Ababa' },
    'SO': { province: '', zip: '', city: 'Mogadishu' },
    'ER': { province: '', zip: '', city: 'Asmara' },
    'DJ': { province: '', zip: '', city: 'Djibouti' },
    'RW': { province: '', zip: '', city: 'Kigali' },
    'BI': { province: '', zip: '', city: 'Gitega' },
    'KM': { province: '', zip: '', city: 'Moroni' },
    'SC': { province: '', zip: '', city: 'Victoria' },
    'MU': { province: '', zip: '', city: 'Port Louis' },
    'MG': { province: '', zip: '101', city: 'Antananarivo' },
    'RE': { province: '', zip: '97400', city: 'Saint-Denis' },
    'YT': { province: '', zip: '97600', city: 'Mamoudzou' },
    
    // Central Africa
    'CD': { province: '', zip: '', city: 'Kinshasa' },
    'CG': { province: '', zip: '', city: 'Brazzaville' },
    'CM': { province: '', zip: '', city: 'Yaoundé' },
    'CF': { province: '', zip: '', city: 'Bangui' },
    'TD': { province: '', zip: '', city: 'NDjamena' },
    'GA': { province: '', zip: '', city: 'Libreville' },
    'GQ': { province: '', zip: '', city: 'Malabo' },
    'AO': { province: '', zip: '', city: 'Luanda' },
    
    // Southern Africa
    'ZA': { province: '', zip: '0001', city: 'Pretoria' },
    'ZW': { province: '', zip: '', city: 'Harare' },
    'ZM': { province: '', zip: '10101', city: 'Lusaka' },
    'MW': { province: '', zip: '', city: 'Lilongwe' },
    'MZ': { province: '', zip: '1100', city: 'Maputo' },
    'BW': { province: '', zip: '', city: 'Gaborone' },
    'NA': { province: '', zip: '9000', city: 'Windhoek' },
    'LS': { province: '', zip: '100', city: 'Maseru' },
    'SZ': { province: '', zip: 'H100', city: 'Mbabane' },
    'SH': { province: '', zip: 'STHL 1ZZ', city: 'Jamestown' }
};

return countryDefaults[countryCode] || { province: '', zip: '10001', city: 'Capital' };
}

function getCustomerEmail() {
return document.querySelector('[name="customer[email]"]')?.value ||
        document.querySelector('[name="email"]')?.value ||
        document.querySelector('#customer_email')?.value ||
        null;
}

function getShippingAddressFromForm() {
const form = document.querySelector('[address-form]') ||
            document.querySelector('#shipping-address') ||
            document.querySelector('.address-form');
if (!form) return null;

return {
    first_name: form.querySelector('[name="first_name"]')?.value || '',
    last_name: form.querySelector('[name="last_name"]')?.value || '',
    address1: form.querySelector('[name="address1"]')?.value || '',
    address2: form.querySelector('[name="address2"]')?.value || '',
    city: form.querySelector('[name="city"]')?.value || '',
    province: form.querySelector('[name="province"]')?.value || form.querySelector('[name="state"]')?.value || '',
    country: form.querySelector('[name="country"]')?.value || '',
    zip: form.querySelector('[name="zip"]')?.value || '',
    phone: form.querySelector('[name="phone"]')?.value || ''
};
}

// Get selected shipping method from radio buttons
function getSelectedShippingMethod() {
const selectedRadio = document.querySelector('input[name="shipping-method"]:checked');
if (selectedRadio) {
    return selectedRadio.value; // 'standard' or 'expedited'
}
// Default to standard if nothing selected
return 'standard';
}

// Fetch shipping rates from Shopify based on GLC country
async function fetchShippingRates(countryCode = null) {
try {
    // Get country from GLC if not provided
    if (!countryCode) {
        const glcData = getGLCCountryData();
        countryCode = glcData.country;
    }
    
    console.log('Fetching shipping rates for country:', countryCode);
    
    // First, get the current cart to extract line items
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    
    if (!cart || !cart.items || cart.items.length === 0) {
        console.warn('Cart is empty, cannot fetch shipping rates');
        return null;
    }

    // Get default address details for this country
    const defaults = getDefaultShippingAddress(countryCode);
    
    // Prepare shipping address for Shopify API
    const address = {
        country: countryCode,
        province: defaults.province,
        zip: defaults.zip,
        city: defaults.city
    };

    console.log('Prepared address for shipping calculation:', address);

    // Use Shopify's shipping rates API endpoint
    const queryParams = new URLSearchParams({
        'shipping_address[country]': address.country,
        'shipping_address[province]': address.province,
        'shipping_address[zip]': address.zip,
        'shipping_address[city]': address.city
    });

    const shippingUrl = `/cart/shipping_rates.json?${queryParams.toString()}`;
    console.log('Fetching from:', shippingUrl);
    
    const shippingResponse = await fetch(shippingUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        }
    });

    if (!shippingResponse.ok) {
        console.error('Shipping rates API error:', shippingResponse.status, shippingResponse.statusText);
        const errorText = await shippingResponse.text();
        console.error('Error details:', errorText);
        return null;
    }

    const shippingData = await shippingResponse.json();
    console.log('Shipping rates response:', shippingData);

    if (shippingData && shippingData.shipping_rates && shippingData.shipping_rates.length > 0) {
        // Get target currency from GLC
        const targetCurrency = getCurrentCurrency();
        
        // Return all available shipping rates with currency conversion
        const rates = shippingData.shipping_rates.map(rate => {
            const priceInINR = parseFloat(rate.price);
            const convertedPrice = convertCurrency(priceInINR, targetCurrency);
            
            return {
                name: rate.name,
                price: convertedPrice,
                price_original: priceInINR,
                code: rate.code || rate.handle,
                delivery_range: rate.delivery_range || null
            };
        });
        
        console.log('Available shipping rates (converted to', targetCurrency + '):', rates);
        return {
            rates: rates,
            default_rate: rates[0], // First rate is typically the default
            currency: targetCurrency
        };
    }

    return null;
} catch (error) {
    console.error('Error fetching shipping rates:', error);
    return null;
}
}

// Alternative method using Shopify Ajax API for shipping calculation
async function calculateShippingViaAjax(countryCode = null) {
try {
    console.log('Calculating shipping via Ajax API...');
    
    // Get country from GLC if not provided
    if (!countryCode) {
        const glcData = getGLCCountryData();
        countryCode = glcData.country;
    }
    
    // Get default address details for this country
    const defaults = getDefaultShippingAddress(countryCode);
    
    // Prepare the shipping address
    const preparedAddress = {
        country: countryCode,
        province: defaults.province,
        zip: defaults.zip
    };

    // Use Shopify's cart/prepare_shipping_rates.json endpoint
    const prepareResponse = await fetch('/cart/prepare_shipping_rates.json', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            shipping_address: preparedAddress
        })
    });

    if (prepareResponse.ok) {
        console.log('Shipping rates preparation successful');
        
        // Poll for shipping rates (they may take a moment to calculate)
        let attempts = 0;
        const maxAttempts = 10;
        
        while (attempts < maxAttempts) {
            await new Promise(resolve => setTimeout(resolve, 500)); // Wait 500ms between attempts
            
            const queryParams = new URLSearchParams({
                'shipping_address[country]': preparedAddress.country,
                'shipping_address[province]': preparedAddress.province,
                'shipping_address[zip]': preparedAddress.zip
            });
            
            const ratesResponse = await fetch(`/cart/async_shipping_rates.json?${queryParams.toString()}`);
            
            if (ratesResponse.ok) {
                const ratesData = await ratesResponse.json();
                console.log('Async shipping rates response:', ratesData);
                
                if (ratesData && ratesData.shipping_rates && ratesData.shipping_rates.length > 0) {
                    // Get target currency from GLC
                    const targetCurrency = getCurrentCurrency();
                    
                    const rates = ratesData.shipping_rates.map(rate => {
                        const priceInINR = parseFloat(rate.price);
                        const convertedPrice = convertCurrency(priceInINR, targetCurrency);
                        
                        return {
                            name: rate.name,
                            price: convertedPrice,
                            price_original: priceInINR,
                            code: rate.code || rate.handle,
                            delivery_range: rate.delivery_range || null
                        };
                    });
                    
                    console.log('Calculated shipping rates (converted to', targetCurrency + '):', rates);
                    return {
                        rates: rates,
                        default_rate: rates[0],
                        currency: targetCurrency
                    };
                }
            }
            
            attempts++;
        }
        
        console.warn('Shipping rates not ready after polling');
    } else {
        console.error('Failed to prepare shipping rates:', prepareResponse.status);
    }
    
    return null;
} catch (error) {
    console.error('Error calculating shipping via Ajax:', error);
    return null;
}
}

// List of currencies that use minor units (cents) in Shopify's pricing
// These currencies show prices like €13,95 but store them as 1395 cents
const MINOR_UNIT_CURRENCIES = ['EUR', 'DKK', 'SEK', 'NOK', 'CZK', 'HUF', 'PLN', 'RON', 'BGN', 'HRK', 'ISK'];

// Helper to normalize prices from Shopify's cart API
// Some currencies are returned in minor units (cents), others in major units (dollars)
function normalizeShopifyPrice(price, currency) {
    if (typeof price !== 'number') {
        price = parseFloat(price);
    }
    
    if (isNaN(price)) {
        return 0;
    }
    
    // Check if this currency uses minor units in Shopify
    // For these currencies, divide by 100 to get the actual price
    if (MINOR_UNIT_CURRENCIES.includes(currency)) {
        // Price is in cents (e.g., 1395 for €13.95)
        return Math.round(price) / 100;
    }
    
    // For other currencies (USD, GBP, CAD, etc.), price is already in major units
    return price;
}

function extractPriceFromText(text) {
if (!text) return 0;
let cleanText = text.trim();
cleanText = cleanText.split('/')[0];

// Handle different decimal separators: period (13.95) or comma (13,95)
// First, try to match standard formats
const periodMatch = cleanText.match(/(\d+\.\d{2})/);
if (periodMatch) {
    return parseFloat(periodMatch[1]);
}

const commaMatch = cleanText.match(/(\d+),(\d{2})/);
if (commaMatch) {
    // Convert comma decimal separator to period
    return parseFloat(commaMatch[1] + '.' + commaMatch[2]);
}

// Fallback: remove all non-digit characters except the last period or comma
cleanText = cleanText.replace(/[^\d.,]/g, '');

// If there's a comma followed by 2 digits at the end, treat it as decimal separator
if (/,\d{2}$/.test(cleanText)) {
    cleanText = cleanText.replace(',', '.');
}

// Remove any remaining commas (thousands separators)
cleanText = cleanText.replace(/,/g, '');

const price = parseFloat(cleanText);
return isNaN(price) ? 0 : price;
}

// Get checkout data from DOM prices (which are updated by GLC app with correct currency)
async function getCheckoutDataFromCart() {
    // Use DOM-based extraction since GLC updates prices dynamically in the frontend
    return getCheckoutDataFromVisiblePrices();
}

function getCheckoutDataFromVisiblePrices() {
const items = [];

// Determine which cart container to use (drawer vs page)
let cartContainer = null;
const cartDrawer = document.getElementById('CartDrawer');
const cartPage = document.querySelector('main .cart, main [id*="cart-items"], main form[action*="cart"]');

// Check if cart drawer is open/visible
const isDrawerVisible = cartDrawer && (
    cartDrawer.classList.contains('active') || 
    cartDrawer.classList.contains('is-open') ||
    window.getComputedStyle(cartDrawer).display !== 'none'
);

// Use drawer if visible, otherwise use cart page
if (isDrawerVisible) {
    cartContainer = cartDrawer;
    console.log('Using cart drawer for data extraction');
} else if (cartPage) {
    cartContainer = cartPage;
    console.log('Using cart page for data extraction');
} else {
    // Fallback to cart drawer if it exists
    cartContainer = cartDrawer || document.body;
    console.log('Using fallback container for data extraction');
}

const allQuantityInputs = cartContainer.querySelectorAll('input[type="number"][name="updates[]"]');
console.log('Found', allQuantityInputs.length, 'quantity inputs in', cartContainer.id || 'container');

const cartQuantityInputs = Array.from(allQuantityInputs).filter(input => {
    const quantity = parseInt(input.value) || 0;
    return quantity > 0;
});

// Helper: try to extract product_id, variant_id and sku from a cart item element
function extractProductMetadata(cartItem) {
    let productId = null;
    let variantId = null;
    let sku = null;

    // 1) dataset and attributes
    if (cartItem.dataset) {
    productId = cartItem.dataset.productId || cartItem.dataset.productid || cartItem.dataset.product || productId;
    variantId = cartItem.dataset.variantId || cartItem.dataset.variantid || cartItem.dataset.variant || variantId;
    sku = cartItem.dataset.sku || sku;
    }
    productId = productId || cartItem.getAttribute('data-product-id') || cartItem.getAttribute('data-productid') || cartItem.getAttribute('data-product');
    variantId = variantId || cartItem.getAttribute('data-variant-id') || cartItem.getAttribute('data-variantid') || cartItem.getAttribute('data-variant');
    sku = sku || cartItem.getAttribute('data-sku');

    // 2) hidden inputs commonly used by Shopify forms (variant id is often in input[name="id"])
    if (!variantId) {
    const idInput = cartItem.querySelector('input[name="id"], input[name="variant_id"], input[name="variantId"]');
    if (idInput && idInput.value) variantId = idInput.value.trim();
    }
    if (!productId) {
    const pInput = cartItem.querySelector('input[name="product_id"], input[name="productId"]');
    if (pInput && pInput.value) productId = pInput.value.trim();
    }

    // 3) SKU elements with common class names or data attributes
    if (!sku) {
    const skuSelectors = ['.sku', '.product-sku', '.variant-sku', '.cart-item__sku', '[data-sku]'];
    for (const sel of skuSelectors) {
        const sEl = cartItem.querySelector(sel);
        if (sEl && sEl.textContent && sEl.textContent.trim()) {
        sku = sEl.textContent.trim();
        break;
        }
    }
    }

    // 4) Look for textual "SKU" label followed by value
    if (!sku) {
    const textCandidates = cartItem.querySelectorAll('*');
    for (const node of textCandidates) {
        if (!node || !node.textContent) continue;
        const txt = node.textContent.trim();
        const m = txt.match(/SKU[:\s]*([^\s]+)/i);
        if (m) {
        sku = m[1].trim();
        break;
        }
        if (/^sku[:\s]/i.test(txt)) {
        // try sibling or next element
        const sib = node.nextElementSibling;
        if (sib && sib.textContent && sib.textContent.trim()) {
            sku = sib.textContent.trim();
            break;
        }
        }
    }
    }

    // 5) Try parsing variant id from links or href query params
    if (!variantId) {
    const variantLink = cartItem.querySelector('a[href*="/variants/"], a[href*="variant="]');
    if (variantLink) {
        const href = variantLink.getAttribute('href') || '';
        const vMatch = href.match(/\/variants\/(\d+)/) || href.match(/[?&]variant=(\d+)/);
        if (vMatch) variantId = vMatch[1];
    }
    }

    // 6) Normalize empty strings to null
    productId = productId ? String(productId).trim() : null;
    variantId = variantId ? String(variantId).trim() : null;
    sku = sku ? String(sku).trim() : null;

    return {
    product_id: productId,
    variant_id: variantId,
    sku: sku
    };
}

cartQuantityInputs.forEach((quantityInput, index) => {
    const cartItem = quantityInput.closest('.cart-item, .cart__row, [data-line-item]');
    
    if (cartItem) {
    const priceElement = cartItem.querySelector('[class*="price"], .cart__price, .product-price, .line-price');
    
    let titleElement = cartItem.querySelector('.cart-item__name');
    if (!titleElement || !titleElement.textContent.trim()) {
        const productLinks = cartItem.querySelectorAll('a[href*="/products/"]');
        for (let link of productLinks) {
        if (link.textContent && link.textContent.trim()) {
            titleElement = link;
            break;
        }
        }
    }
    
    if (priceElement) {
        const displayedPrice = extractPriceFromText(priceElement.textContent);
        const quantity = parseInt(quantityInput.value) || 1;
        
        if (displayedPrice > 0) {
        let productTitle = 'Product ' + (index + 1);
        
        if (titleElement && titleElement.textContent.trim()) {
            productTitle = titleElement.textContent.trim().replace(/\s+/g, ' ').trim();
        }

        // extract product metadata (product_id, variant_id, sku)
        const meta = extractProductMetadata(cartItem);
        
        items.push({
            title: productTitle,
            displayed_price: displayedPrice,
            quantity: quantity,
            line_total: displayedPrice * quantity,  // FIX: Must multiply by quantity for PayPal
            currency: getCurrentCurrency(),
            product_id: meta.product_id,
            variant_id: meta.variant_id,
            sku: meta.sku
        });
        }
    }
    }
});

const totalElement = document.querySelector('.totals__total-value, .cart__total, .total-price');
const total = totalElement ? extractPriceFromText(totalElement.textContent) : 
            items.reduce((sum, item) => sum + item.line_total, 0);

return {
    items: items,
    total: total,
    currency: getCurrentCurrency(),
    customer_email: getCustomerEmail(),
    shipping_address: getShippingAddressFromForm()
};
}

function isInternationalCustomer() {
getCurrentCurrency();
return currentCurrency !== 'INR';
}

function showLoading(button) {
isProcessing = true;
const originalHTML = button.innerHTML;
button.setAttribute('data-original-html', originalHTML);
button.innerHTML = `
    <span class="paypal-loading" style="display: inline-flex; align-items: center; justify-content: center; gap: 8px;">
    <svg style="animation: paypal-spin 1s linear infinite; width: 20px; height: 20px;" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" stroke-opacity="0.25"/>
        <path d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" fill="currentColor" opacity="0.75"/>
    </svg>
    Processing with PayPal...
    </span>
`;
button.style.opacity = '0.7';
button.style.cursor = 'wait';
button.disabled = true;
}

function hideLoading(button) {
isProcessing = false;
const originalHTML = button.getAttribute('data-original-html');
if (originalHTML) {
    button.innerHTML = originalHTML;
}
button.style.opacity = '';
button.style.cursor = '';
button.disabled = false;
button.removeAttribute('data-original-html');
}

async function initiateInternationalCheckout(button) {
if (isProcessing) return;
showLoading(button);
console.log("Initiating international payments for currency:", currentCurrency);

try {
    // Use the cart API to get accurate prices
    const checkoutData = await getCheckoutDataFromCart();
    const zapierWebhookURL = 'https://raspy-mountain-2631.varun9509.workers.dev/';
    
    // Fetch shipping rates based on GLC country
    let shippingInfo = null;
    const glcData = getGLCCountryData();
    const selectedMethod = getSelectedShippingMethod();
    
    console.log('Fetching shipping rates for GLC country:', glcData.country);
    console.log('Selected shipping method:', selectedMethod);
    
    shippingInfo = await fetchShippingRates(glcData.country);
    
    // If the first method fails, try the alternative Ajax API method
    if (!shippingInfo) {
        console.log('Trying alternative shipping calculation method...');
        shippingInfo = await calculateShippingViaAjax(glcData.country);
    }
    
    // Add shipping info to checkout data
    if (shippingInfo && shippingInfo.rates && shippingInfo.rates.length > 0) {
        // Find the selected shipping rate based on the radio button selection
        let selectedRate = null;
        
        if (selectedMethod === 'standard') {
            selectedRate = shippingInfo.rates.find(r => r.name.toLowerCase().includes('standard'));
        } else if (selectedMethod === 'expedited') {
            selectedRate = shippingInfo.rates.find(r => 
                r.name.toLowerCase().includes('expedited') || 
                r.name.toLowerCase().includes('express')
            );
        }
        
        // Fallback to first rate if specific rate not found
        if (!selectedRate) {
            selectedRate = shippingInfo.rates[0];
            console.warn('Could not find', selectedMethod, 'rate, using default:', selectedRate.name);
        }

        // Get target currency from GLC
        const targetCurrency = getCurrentCurrency();
        
        checkoutData.shipping = {
            name: selectedRate.name,
            price: selectedRate.price,                          // Presentment currency
            price_original: selectedRate.price_original,        // Shop currency (INR)
            price_shipping: convertCurrency(selectedRate.price_original, targetCurrency),  // Always USD for PayPal
            code: selectedRate.code,
            delivery_range: selectedRate.delivery_range,
            country: glcData.country,
            method: selectedMethod
        };
        // Add shipping cost to total (already in presentment currency) and round to 2 decimal places
        checkoutData.total = Math.round((checkoutData.total + selectedRate.price) * 100) / 100;
        console.log('Selected shipping method:', selectedMethod);
        console.log('Shipping rate:', selectedRate);
        console.log('New total with shipping:', checkoutData.total);
    } else {
        console.warn('Could not fetch shipping rates - proceeding without shipping');
    }

    console.log(checkoutData);
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 15000);

    const response = await fetch(zapierWebhookURL, {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
    },
    body: JSON.stringify(checkoutData),
    signal: controller.signal
    });

    clearTimeout(timeoutId);
    
    // Check if response is OK
    if (!response.ok) {
    const errorText = await response.text();
    console.error('PayPal API Error Response:', {
        status: response.status,
        statusText: response.statusText,
        body: errorText
    });
    hideLoading(button);
    alert(`Unable to process PayPal payment. Error: ${response.status} ${response.statusText}`);
    return;
    }
    
    const result = await response.json();
    console.log('PayPal API Full Response:', result);
    
    // Check for error in response
    if (result.error || result.message) {
    console.error('PayPal Error:', result.error || result.message);
    hideLoading(button);
    alert(`Unable to process PayPal payment. ${result.error || result.message}`);
    return;
    }
    
    let paypalUrl = null;

    if (result.payment_link) {
    paypalUrl = result.payment_link;
    } else if (result.links && result.links[1] && result.links[1].href) {
    paypalUrl = result.links[1].href;
    } else if (result.links && result.links[0] && result.links[0].href) {
    paypalUrl = result.links[0].href;
    } else if (result.links) {
    const approveLink = result.links.find(link =>
        link.rel === 'approve' ||
        link.method === 'GET' ||
        (link.href && link.href.includes('paypal.com/checkoutnow'))
    );
    if (approveLink && approveLink.href) {
        paypalUrl = approveLink.href;
    }
    }

    if (paypalUrl) {
    console.log('Redirecting to PayPal:', paypalUrl);
    window.location.href = paypalUrl;
    } else {
    console.error('No PayPal URL found in response. Full response:', JSON.stringify(result, null, 2));
    hideLoading(button);
    alert('Unable to process PayPal payment. Please check console for details or contact support.');
    }

} catch (error) {
    console.error('Error:', error);
    hideLoading(button);
    if (error.name === 'AbortError') {
    alert('Payment request timed out. Please try again.');
    } else {
    alert('An error occurred while processing your payment. Please try again.');
    }
}
}

function getSelectedPaymentMethod() {
// Helper function to check if element is visible
const isVisible = (element) => {
    if (!element) return false;
    const parent = element.closest('.payment-method-selector');
    if (!parent) return false;
    const style = window.getComputedStyle(parent);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
};

// Check cart drawer radio buttons
const drawerRadio = document.querySelector('input[name="payment-method-drawer"]:checked');
const drawerVisible = isVisible(drawerRadio);
console.log('Drawer radio found:', drawerRadio, 'Value:', drawerRadio?.value, 'Visible:', drawerVisible);
if (drawerRadio && drawerVisible) {
    console.log('Using drawer payment method:', drawerRadio.value);
    return drawerRadio.value;
}

// Check cart page radio buttons
const cartRadio = document.querySelector('input[name="payment-method-cart"]:checked');
const cartVisible = isVisible(cartRadio);
console.log('Cart radio found:', cartRadio, 'Value:', cartRadio?.value, 'Visible:', cartVisible);
if (cartRadio && cartVisible) {
    console.log('Using cart page payment method:', cartRadio.value);
    return cartRadio.value;
}

// Default to paypal for international customers
console.log('No payment method selected, defaulting to paypal');
return 'paypal';
}

function handleCheckoutClick(e) {
if (isInternationalCustomer()) {
    console.log('=== CHECKOUT CLICK DEBUG ===');
    console.log('International customer detected, currency:', currentCurrency);
    
    const paymentMethod = getSelectedPaymentMethod();
    console.log('Selected payment method:', paymentMethod);
    
    // If user selected Shopify checkout, allow normal checkout flow
    if (paymentMethod === 'shopify') {
    console.log("User selected Shopify checkout, proceeding normally");
    console.log('=== END DEBUG ===');
    return true;
    }
    
    // Otherwise, redirect to PayPal
    console.log('Intercepting checkout for PayPal');
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    console.log("Intercepted checkout for currency:", currentCurrency);
    const button = e.target.closest('button') ||
                e.target.closest('a') ||
                e.target.closest('[href*="checkout"]') ||
                e.target;
    console.log('=== END DEBUG ===');
    initiateInternationalCheckout(button);
    return false;
}
}

function attachCheckoutListeners() {
const checkoutButtons = document.querySelectorAll(
    '[href*="checkout"], .checkout-button, #checkout, #CartDrawer-Checkout, button[name="checkout"], [data-checkout-button]'
);

console.log('Attaching listeners to', checkoutButtons.length, 'checkout buttons');

checkoutButtons.forEach(button => {
    const newButton = button.cloneNode(true);
    newButton.setAttribute('data-paypal-managed', '1');
    button.parentNode.replaceChild(newButton, button);
    newButton.addEventListener('click', handleCheckoutClick, true);
    updateButtonAppearance(newButton);
});

// Update payment method selector after attaching listeners
const selectorUpdated = updatePaymentMethodSelector();

// If selector not found, retry a few times as cart drawer might still be loading
if (!selectorUpdated) {
    let retries = 0;
    const maxRetries = 5;
    const retryInterval = setInterval(() => {
        retries++;
        if (updatePaymentMethodSelector() || retries >= maxRetries) {
            clearInterval(retryInterval);
        }
    }, 200);
}
}

function updatePaymentMethodSelector() {
const drawerSelector = document.getElementById('CartDrawer-PaymentMethodSelector');
const cartSelector = document.getElementById('Cart-PaymentMethodSelector');

console.log('updatePaymentMethodSelector called');
console.log('Drawer selector:', drawerSelector);
console.log('Cart selector:', cartSelector);

if (!drawerSelector && !cartSelector) {
    console.log('Payment method selectors not found in DOM yet');
    return false;
}

// Update currency display in radio options
const currencyDisplays = document.querySelectorAll('.payment-method-selector .currency-display');
currencyDisplays.forEach(display => {
    display.textContent = currentCurrency;
});

if (isInternationalCustomer()) {
    if (drawerSelector) {
        drawerSelector.style.display = 'block';
        console.log('Cart drawer payment method selector shown for currency:', currentCurrency);
    }
    if (cartSelector) {
        cartSelector.style.display = 'block';
        console.log('Cart page payment method selector shown for currency:', currentCurrency);
    }
} else {
    if (drawerSelector) drawerSelector.style.display = 'none';
    if (cartSelector) cartSelector.style.display = 'none';
    console.log('Payment method selectors hidden (domestic customer)');
}

return true;
}

function updateButtonAppearance(button) {
const existingIndicator = button.querySelector('.paypal-indicator');
if (existingIndicator) {
    existingIndicator.remove();
}

if (button.hasAttribute('data-original-href')) {
    button.href = button.getAttribute('data-original-href');
    button.removeAttribute('data-original-href');
}

if (isInternationalCustomer()) {
    const indicator = document.createElement('span');
    indicator.className = 'paypal-indicator';
    indicator.textContent = ` (PayPal - ${currentCurrency})`;
    indicator.style.cssText = 'color: #003087; font-size: 0.85em; margin-left: 5px; font-weight: 500;';
    //button.appendChild(indicator);

    if (button.tagName === 'A') {
    if (button.href && button.href.includes('/checkout')) {
        button.setAttribute('data-original-href', button.href);
        button.href = 'javascript:void(0);';
    }

    if (button.textContent.includes('Checkout') && !button.textContent.includes('PayPal')) {
        button.textContent = button.textContent.replace('Checkout', `Checkout with PayPal`);
    }
    }
} else if (button.getAttribute('data-original-href')) {
    button.href = button.getAttribute('data-original-href');
    button.removeAttribute('data-original-href');
}

// Update payment method selector visibility
updatePaymentMethodSelector();
}

function setupMutationObserver() {
if (observerInitialized) return;

const observer = new MutationObserver((mutations) => {
    let shouldReattach = false;
    let shouldUpdateSelector = false;

    mutations.forEach((mutation) => {
    if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
            if (node.getAttribute && node.getAttribute('data-paypal-managed') === '1') {
            return;
            }

            // Check for checkout buttons
            if (node.querySelector &&
                (node.querySelector('[href*="checkout"]') ||
                node.querySelector('.checkout-button') ||
                node.querySelector('#checkout') ||
                node.querySelector('#CartDrawer-Checkout'))) {
            shouldReattach = true;
            }

            if (node.matches &&
                (node.matches('[href*="checkout"]') ||
                node.matches('.checkout-button') ||
                node.matches('#checkout') ||
                node.matches('#CartDrawer-Checkout'))) {
            shouldReattach = true;
            }

            // Check for payment method selector or cart drawer
            if (node.querySelector &&
                (node.querySelector('#CartDrawer-PaymentMethodSelector') ||
                node.querySelector('#Cart-PaymentMethodSelector') ||
                node.querySelector('.cart-drawer__footer') ||
                node.querySelector('.cart__ctas') ||
                node.querySelector('.payment-method-selector'))) {
            shouldUpdateSelector = true;
            console.log('Payment method selector added to DOM');
            }

            if (node.matches &&
                (node.matches('#CartDrawer-PaymentMethodSelector') ||
                node.matches('#Cart-PaymentMethodSelector') ||
                node.matches('.cart-drawer__footer') ||
                node.matches('.cart__ctas') ||
                node.matches('.payment-method-selector'))) {
            shouldUpdateSelector = true;
            console.log('Payment method selector element detected');
            }

            // Check for cart drawer itself
            if (node.id === 'CartDrawer' || node.classList?.contains('drawer')) {
            shouldReattach = true;
            shouldUpdateSelector = true;
            console.log('Cart drawer added to DOM');
            }
        }
        });
    }
    });

    if (shouldReattach) {
    console.log('Cart updated, re-attaching checkout listeners');
    setTimeout(() => {
        attachCheckoutListeners();
        getCurrentCurrency();
    }, 100);
    } else if (shouldUpdateSelector) {
    // Just update the selector without re-attaching all listeners
    console.log('Updating payment method selector');
    setTimeout(() => {
        updatePaymentMethodSelector();
    }, 100);
    }
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

observerInitialized = true;
console.log('MutationObserver initialized');
}

function monitorCurrency() {
let lastCurrency = currentCurrency;

const checkAndUpdate = () => {
    getCurrentCurrency();
    if (currentCurrency !== lastCurrency) {
    console.log(`Currency changed from ${lastCurrency} to ${currentCurrency}`);
    lastCurrency = currentCurrency;
    attachCheckoutListeners();
    }
};

setInterval(checkAndUpdate, 500);

window.addEventListener('storage', function(e) {
    if (e.key === 'glc_switcher') {
    setTimeout(checkAndUpdate, 100);
    }
});

if (typeof Shopify !== 'undefined') {
    document.addEventListener('ajaxCart.afterCartLoad', function() {
    console.log('Cart loaded via AJAX, updating checkout buttons');
    setTimeout(() => {
        attachCheckoutListeners();
        checkAndUpdate();
    }, 300);
    });
}
}

function setupCartDrawerListeners() {
// Listen for cart drawer opening events
const cartDrawer = document.getElementById('CartDrawer');
if (cartDrawer) {
    console.log('Cart drawer found, setting up listeners');
    
    // Watch for when drawer becomes visible
    const drawerObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const isOpen = cartDrawer.classList.contains('active') || 
                             cartDrawer.classList.contains('is-open') ||
                             !cartDrawer.classList.contains('is-empty');
                
                if (isOpen) {
                    console.log('Cart drawer opened, updating payment selector');
                    setTimeout(() => {
                        getCurrentCurrency();
                        updatePaymentMethodSelector();
                    }, 150);
                }
            }
        });
    });
    
    drawerObserver.observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['class']
    });
}

// Check if we're on the cart page and update selector
const cartPageSelector = document.getElementById('Cart-PaymentMethodSelector');
if (cartPageSelector) {
    console.log('Cart page detected, updating payment selector');
    setTimeout(() => {
        getCurrentCurrency();
        updatePaymentMethodSelector();
    }, 100);
}

// Listen for cart update events from Shopify theme
document.addEventListener('cart:updated', () => {
    console.log('Cart updated event detected');
    setTimeout(() => {
        updatePaymentMethodSelector();
    }, 200);
});

// Listen for theme-specific cart drawer events
const cartDrawerEvents = ['cart-drawer:open', 'drawer:open', 'shopify:section:load'];
cartDrawerEvents.forEach(eventName => {
    document.addEventListener(eventName, () => {
        console.log(`${eventName} event detected`);
        setTimeout(() => {
            updatePaymentMethodSelector();
        }, 200);
    });
});
}

function initializeCheckoutSystem() {
console.log('Initializing checkout system...');
getCurrentCurrency();
attachCheckoutListeners();
setupMutationObserver();
setupCartDrawerListeners();
monitorCurrency();

setTimeout(() => {
    getCurrentCurrency();
    attachCheckoutListeners();
}, 1500);
}

if (document.readyState === 'loading') {
document.addEventListener('DOMContentLoaded', initializeCheckoutSystem);
} else {
initializeCheckoutSystem();
}

if (typeof Turbo !== 'undefined') {
document.addEventListener('turbo:load', initializeCheckoutSystem);
}

window.addEventListener('pageshow', initializeCheckoutSystem);

// Helper function for testing shipping calculation in console
window.testShippingCalculation = async function(countryCode = null) {
    // Get country from GLC if not provided
    if (!countryCode) {
        const glcData = getGLCCountryData();
        countryCode = glcData.country;
        console.log('Using country from GLC Geolocation app:', glcData);
    }
    
    console.log('=== TESTING SHIPPING CALCULATION ===');
    console.log('Country code:', countryCode);
    
    // Method 1: Direct shipping rates
    console.log('\n--- Method 1: Direct Shipping Rates API ---');
    const rates1 = await fetchShippingRates(countryCode);
    if (rates1) {
        console.log('✓ Success! Shipping rates:', rates1);
    } else {
        console.log('✗ Failed to fetch shipping rates');
    }
    
    // Method 2: Ajax API
    console.log('\n--- Method 2: Ajax Shipping Calculation ---');
    const rates2 = await calculateShippingViaAjax(countryCode);
    if (rates2) {
        console.log('✓ Success! Shipping rates:', rates2);
    } else {
        console.log('✗ Failed to calculate shipping via Ajax');
    }
    
    console.log('\n=== TEST COMPLETE ===');
    
    return {
        country: countryCode,
        method1: rates1,
        method2: rates2
    };
};

// Helper to view GLC data
window.viewGLCData = function() {
    const glcData = getGLCCountryData();
    console.log('=== GLC GEOLOCATION DATA ===');
    console.log('Country:', glcData.country);
    console.log('Currency:', glcData.currency);
    console.log('Locale:', glcData.locale);
    console.log('\nRaw localStorage value:');
    console.log(localStorage.getItem('glc_switcher'));
    return glcData;
};

// Helper to view current checkout data with shipping
window.viewCheckoutDataWithShipping = async function() {
    console.log('=== CHECKOUT DATA WITH SHIPPING ===');
    
    const checkoutData = await getCheckoutDataFromCart();
    console.log('\n1. Base checkout data (normalized from cart API):', checkoutData);
    
    const glcData = getGLCCountryData();
    const selectedMethod = getSelectedShippingMethod();
    console.log('\n2. GLC Country Data:', glcData);
    console.log('   Selected shipping method:', selectedMethod);
    
    console.log('\n3. Fetching shipping rates for', glcData.country, '...');
    let shippingInfo = await fetchShippingRates(glcData.country);
    
    if (!shippingInfo) {
        console.log('   Trying alternative method...');
        shippingInfo = await calculateShippingViaAjax(glcData.country);
    }
    
    if (shippingInfo && shippingInfo.rates && shippingInfo.rates.length > 0) {
        // Find the selected shipping rate
        let selectedRate = null;
        
        if (selectedMethod === 'standard') {
            selectedRate = shippingInfo.rates.find(r => r.name.toLowerCase().includes('standard'));
        } else if (selectedMethod === 'expedited') {
            selectedRate = shippingInfo.rates.find(r => 
                r.name.toLowerCase().includes('expedited') || 
                r.name.toLowerCase().includes('express')
            );
        }
        
        if (!selectedRate) {
            selectedRate = shippingInfo.rates[0];
        }
        
        checkoutData.shipping = {
            method: selectedMethod,
            rate: selectedRate,
            all_rates: shippingInfo.rates,
            country: glcData.country
        };
        checkoutData.total_with_shipping = Math.round((checkoutData.total + selectedRate.price) * 100) / 100;
        
        console.log('\n4. ✓ Shipping added successfully!');
        console.log('   Country:', glcData.country);
        console.log('   Selected method:', selectedMethod);
        console.log('   Selected rate:', selectedRate);
        console.log('   All available rates:', shippingInfo.rates);
        console.log('   Original total:', checkoutData.total, glcData.currency);
        console.log('   Shipping cost:', selectedRate.price, glcData.currency);
        console.log('   Total with shipping:', checkoutData.total_with_shipping, glcData.currency);
    } else {
        console.log('\n4. ✗ Could not fetch shipping rates');
    }
    
    console.log('\n5. Final checkout data:', checkoutData);
    console.log('\n=== END ===');
    
    return checkoutData;
};